import { render, staticRenderFns } from "./editAcademicCalendar.vue?vue&type=template&id=7af19fbb"
import script from "./editAcademicCalendar.vue?vue&type=script&lang=js"
export * from "./editAcademicCalendar.vue?vue&type=script&lang=js"
import style0 from "./editAcademicCalendar.vue?vue&type=style&index=0&id=7af19fbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports